import { DigitalJourneyRoute } from "app/DigitalJourneyAppFlow/constants";
import Checkpoint from "../../components/Checkpoint";
import { AppRoute } from "./constants";
import { PageProps } from "./types";

export const FlowPage = ({ element, checkpoint, path }: PageProps) => {
  return (
    <Checkpoint checkpoint={checkpoint} path={path as AppRoute & DigitalJourneyRoute}>
      {element}
    </Checkpoint>
  );
};
